import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchState } from '../reducers/integration-management-search.reducer';
import * as selectors from '../selectors/integration-management-search.selectors';

@Injectable({ providedIn: 'root' })
export class IMSearchFacadeService extends FacadeService {
  constructor(public override store: Store<SearchState>) {
    super(store);
  }

  // OBSERVABLES

  systems$ = this.storeSelect(selectors.getSystems);
  selectedSystem$ = this.storeSelect(selectors.getSelectedSystem);
  selectedName$ = this.storeSelect(selectors.getName);
  nameValue$ = this.storeSelect(selectors.getNameValue);
  activeStatus$ = this.storeSelect(selectors.getActiveStatus);
  inActiveStatus$ = this.storeSelect(selectors.getInActiveStatus);
  panelExpandedValue$ = this.storeSelect(selectors.getPanelExpandedValue);

  // OBSERVABLE'S VALUES

  get selectedSystem() {
    return this.storeSnapshot(this.selectedSystem$);
  }

  get selectedName() {
    return this.storeSnapshot(this.selectedName$);
  }

  get activeStatus() {
    return this.storeSnapshot(this.activeStatus$);
  }

  get inActiveStatus() {
    return this.storeSnapshot(this.inActiveStatus$);
  }

  get panelExpandedValue() {
    return this.storeSnapshot(this.panelExpandedValue$);
  }

  get systems() {
    return this.storeSnapshot(this.systems$);
  }
}
